import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { UserService } from "@/services";
import { useSnackbar } from "@/hooks";
import { PathConstant } from "@/const";

export const useResetPassword = () => {
  const { t: getLabel } = useTranslation();
  const { openSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const resetPasswordMutation = useMutation({
    mutationFn: (id: string) => UserService.resetPassword(id),
    onSuccess: () => {
      openSnackbar(getLabel("MSG_RESET_PW"), "success");
      navigate(PathConstant.MN_USER);
    },
    onError: () => openSnackbar(getLabel("MSG_UPDATE_FAILURE"), "error"),
  });

  const resetPassword = (uid: string) => {
    resetPasswordMutation.mutate(uid);
  };

  return {
    resetPassword,
  };
};
